import { words } from '../../locales/keys';

import {
  ComposerAspectRatioOption,
  ComposerAspectRatioValue
} from './composerTypes';

export const enum ComposerPermissions {
  READ_COMPOSER_RENDER_GENERATOR = 'read_composer_render_generator'
}

// Fallback used only if the composer canvas hasn't reported a real viewport
// size yet (e.g. getViewportInfo unavailable) — should not happen in practice.
export const DEFAULT_REQUESTED_SIZE = 1500;

// Kept as a standalone copy rather than importing from the modelViewers
// domain — composer stays self-contained with no cross-module dependency.
export const composerAspectRatios: ComposerAspectRatioOption[] = [
  { value: ComposerAspectRatioValue.AUTO, i18nLabel: words.auto },
  { value: ComposerAspectRatioValue.RATIO_16_9, label: '16:9' },
  { value: ComposerAspectRatioValue.RATIO_4_3, label: '4:3' },
  { value: ComposerAspectRatioValue.RATIO_1_1, label: '1:1' },
  { value: ComposerAspectRatioValue.CUSTOM, i18nLabel: words.custom }
];

export const composerAspectRatioValues: Partial<
  Record<ComposerAspectRatioValue, { width: number; height: number }>
> = {
  [ComposerAspectRatioValue.RATIO_16_9]: { width: 16, height: 9 },
  [ComposerAspectRatioValue.RATIO_4_3]: { width: 4, height: 3 },
  [ComposerAspectRatioValue.RATIO_1_1]: { width: 1, height: 1 }
};
